import PropTypes from 'prop-types'

export default PropTypes.shape({
  count: PropTypes.number,
  id: PropTypes.string,
  name: PropTypes.string,
})
